export const plans = [
  {
    title: "Free trial",
    subtitle: "For anyone",
    description:
      "Try our user-friendly platform for yourself to create PDP images, lifestyles, and more.",
    price: "Free",
    annualPeriod: "",
    monthlyPeriod: "14-day limited trial",
    buttonText: "Start a free trial",
    buttonLink: "https://app.all3d.ai/register",
    buttonClassName: "free-trial-button",
    featuresHeading: "Includes:",
    features: [
      "10 model uploads",
      "5 lifestyle images",
      "10 ALL3D product models",
      "2 ALL3D space models",
      "Use of Scene Creator",
      "Sharing and cloud storage",
    ],
  },
  {
    title: "ALL3D Basic",
    subtitle: "For small sellers",
    description:
      "Create PDP imagery and assets for about 50 products annually.",
    price: "$375",
    annualPeriod: "/month billed annually",
    monthlyPeriod: "Or $416/month billed monthly",
    buttonText: "Sign up for Basic",
    buttonLink: "https://app.all3d.ai/register",
    discount: "Save 10% on annual billing",
    featuresHeading: "Plus!",
    features: [
      "10 model uploads",
      "50 ALL3D product models",
      "5 ALL3D space models",
      "Use of Scene Creator",
      "Sharing and cloud storage",
    ],
    tableData: [
      { service: "3D/AR model creation", value: "12" },
      { service: "Product images", value: "32" },
      { service: "Lifestyle images", value: "20" },
      { service: "360 spins", value: "12" },
      { service: "AR View in room", value: "12" },
    ],
  },
  {
    title: "ALL3D Premium",
    subtitle: "For mid-size sellers",
    description:
      "Create PDP imagery and assets for about 200 products annually.",
    price: "$899",
    annualPeriod: "/month billed annually",
    monthlyPeriod: "Or $999/month billed monthly",
    buttonText: "Sign up for Premium",
    buttonLink: "https://app.all3d.ai/register",
    discount: "Save 10% on annual billing",
    featuresHeading: "Plus!",
    features: [
      "20 model uploads",
      "200 ALL3D product models",
      "10 ALL3D space models",
      "Use of Scene Creator",
      "Sharing and cloud storage",
    ],
    tableData: [
      { service: "3D/AR model creation", value: "24" },
      { service: "Product images", value: "64" },
      { service: "Lifestyle images", value: "40" },
      { service: "360 spins", value: "24" },
      { service: "AR View in room", value: "24" },
    ],
  },
  {
    title: "ALL3D Enterprise",
    subtitle: "For large businesses",
    description:
      "Give your team access to create and collaborate on all of your ecommerce assets.",
    price: "Let's talk",
    annualPeriod: "",
    monthlyPeriod: "Get a demo to learn more",
    buttonText: "Schedule a demo",
    buttonLink: "https://all3d.ai/contact-us",
    featuresHeading: "Includes all services, plus:",
    features: [
      "Custom plan based on image & asset needs",
      "Multiple seat licenses",
      "Dedicated support",
      "Account manager",
      "Designer",
      "3D configurator",
    ],
  },
];

export const bundles = [
  {
    title: "AR Pro",
    alert: "Popular with Amazon sellers",
    description:
      "Ideal for increasing conversion on a product with AR enhancement.",
    price: "$150",
    buttonText: "Buy AR Pro",
    featuresHeading: "Includes:",
    features: ["3D/AR model creation", "AR view in room"],
  },
  {
    title: "PDP Lite",
    description: "Ideal for quickly launching a new product.",
    price: "$599",
    buttonText: "Buy PDP Lite",
    featuresHeading: "Includes:",
    features: [
      "3D model creation",
      "4 silo product images",
      "1 dimensional image",
      "1 lifestyle image",
    ],
  },
  {
    title: "PDP Plus",
    description:
      "Ideal for increasing sales in a competitive marketplace with more product views.",
    price: "$749",
    buttonText: "Buy PDP Plus",
    featuresHeading: "Includes:",
    features: [
      "3D/AR model creation",
      "4 silo product images",
      "1 dimensional image",
      "1 lifestyle image",
      "360 spin",
      "AR view in room",
    ],
  },
];

export const users = [
  {
    icon: "/amazon_icon.svg",
    title: "Amazon Sellers",
    description:
      "Get all your listing photography and AR view in room in one place.",
  },
  {
    icon: "/basket.svg",
    title: "Online DTC Brands",
    description:
      "Easily create product and lifestyle photos to use on your ecommerce site and marketing on social media channels.",
  },
  {
    icon: "/solar_shop.svg",
    title: "Large Retailers",
    description:
      "Get all your manufacturer models in one place to create multi-vendor lifestyle content quickly and easily.",
  },
  {
    icon: "/clarity_factory.svg",
    title: "Manufacturers",
    description:
      "Create prototypes of products, show your products in beautiful spaces and generate all your virtual content in one place.",
  },
  {
    icon: "/pencil_scale.svg",
    title: "Interior Designers",
    description:
      "Create photorealistic images, 360s and 3D tours of designs for your clients. Quickly create engaging social media content.",
  },
  {
    icon: "/real_estate.svg",
    title: "Real Estate Agencies",
    description:
      "Create 3D room tours and photorealistic staging images of high-profile listings to reach more potential clients.",
  },
];

export const brands = [
  { name: "Anthony", path: "/brands/nathan_anthony.svg" },
  { name: "Novogratz", path: "/brands/novogratz.svg" },
  { name: "Skyline Furniture", path: "/brands/skyline.svg" },
  { name: "Safavieh", path: "/brands/safavieh.svg" },
  { name: "RH", path: "/brands/rh_logo.svg" },
  { name: "Walmart", path: "/brands/wallmart.svg" },
  { name: "The Home Depot", path: "/brands/the_home_depot.svg" },
  { name: "Uttermost", path: "/brands/uttermost.svg" },
  { name: "Basset", path: "/brands/basset.svg" },
  { name: "hooker", path: "/brands/hooker.svg" },
];

export const features = [
  {
    title: "3D/AR Model Creation",
    description:
      "It all starts with creating accurate 3D models of your products and variants.",
    image: "/features/feature_chair.png",
    featuresList: [
      {
        title: "3D product models",
        description:
          "High-quality, accurate 3D models of your products we create or you can upload",
      },
      {
        title: "Product variants",
        description:
          "Multiple variants or SKUs of your product in different colors, materials, etc.",
      },
      {
        title: "AR product models",
        description:
          "Realistic AR product models for your PDP's view in room feature",
      },
      {
        title: "3D space models",
        description:
          "Single or connected rooms to create lifestyles, 360 room spins, or 3D tours",
      },
    ],
  },
  {
    title: "Photorealistic Images & Assets",
    description:
      "Manage all your assets in one place – from silos, 360 spins, and AR for your PDP to imagery and lifestyles for marketing and social.",
    image: "/features/cycle.png",
    featuresList: [
      {
        title: "Silo & dimensional images",
        description:
          "Clear product shots in multiple angles on a white or gray background, with or without dimensions",
      },
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "360 product spins",
        description:
          "A 360 animated spin of your product showcasing all angles",
      },
      {
        title: "AR view in room",
        description: "Uses an AR model to allow the view in room feature",
      },
    ],
  },
  {
    title: "Scene Creator Tool",
    description:
      "Scene Creator places your product into a styled vignette or room scene to create lifestyle images showing your product’s scale and use.",
    image: "/features/scene_creator.png",
    featuresList: [
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "3D tour of spaces",
        description:
          "A 360 spin of a room scene showcasing your product or designed space",
      },
      {
        title: "Design services available",
        description:
          "Work with a designer to style custom scenes for your product’s lifestyle images",
        isAdd: true,
      },
      {
        title: "Training available",
        description:
          "Get your team up to speed faster using our platform with a training session",
        isAdd: true,
      },
    ],
  },
  {
    title: "Free ALL3D Store Models",
    description:
      "You’ll have free access to the ALL3D store to use a wide variety of 3D models including products, props, spaces, and scene templates.",
    image: "/features/store_models.png",
    featuresList: [
      {
        title: "Free product & prop models",
        description:
          "Browse a variety of products and props to style with your product for a lifestyle image",
      },
      {
        title: "Free spaces",
        description:
          "Place your products and other props into a space to create a unique lifestyle environment",
      },
      {
        title: "Free styled scene templates",
        description:
          "Choose from a variety of styled scenes to place your product for a quick lifestyle image",
      },
    ],
  },
  {
    title: "Sharing & Cloud Storage",
    description:
      "With your asset library in the cloud, you can easily share and collaborate with your team on your 3D models, scenes, and images.",
    image: "/features/cloud_storage.png",
    featuresList: [
      {
        title: "Share and collaborate",
        description:
          "Ability to share and collaborate with your team on models and designs",
      },
      {
        title: "Cloud storage",
        description:
          "Unlimited cloud storage for your model and asset libraries",
      },
    ],
  },
];

export const faqs = [
  {
    question: "How does the free trial work?",
    answer:
      "Our free trial gives you full access to all features for 14 days. No credit card required.",
  },
  {
    question: "What features can I access once I have an ALL3D account?",
    answer:
      "With an ALL3D account, you get access to our complete suite of 3D modeling tools, rendering capabilities, and collaboration features.",
  },
  {
    question: "How do subscriptions work?",
    answer:
      "Subscriptions are billed monthly or annually. Choose the plan that best fits your needs and scale up or down as needed.",
  },
  {
    question:
      "Are there additional costs associated with a subscription? What if I need less or more each month?",
    answer:
      "Your subscription covers all core features. You can upgrade or downgrade your plan at any time to match your usage needs.",
  },
  {
    question: "How does an enterprise account work?",
    answer:
      "Enterprise accounts offer custom solutions, dedicated support, and advanced features for large organizations.",
  },
  {
    question: "What if I need something not included in a bundle?",
    answer:
      "Contact our sales team to discuss custom solutions and additional features not included in standard bundles.",
  },
  {
    question: "Is there training available?",
    answer:
      "Yes, we offer comprehensive training resources, including video tutorials, documentation, and live webinars.",
  },
  {
    question: "What is the cancellation or return policy?",
    answer:
      "You can cancel your subscription at any time. Refunds are processed according to our terms of service.",
  },
];